export default "__VITE_ASSET__9ff8a018__"